import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PublicLayout, PageContainer, PageHeader } from "@/components/PublicLayout";
import { useSeo } from "@/lib/useSeo";
import { LoadingState, ErrorState, EmptyState } from "@/components/States";
import { ArrowRight } from "@phosphor-icons/react";

export default function Blog() {
  useSeo({ title: "Guwahati Morning Teer Blog | News & Result Articles", description: "Latest Guwahati Morning Teer news, updates and informational articles about Morning Teer results.", path: "/blog" });
  const q = useQuery({ queryKey: ["blog"], queryFn: async () => (await api.get("/blog")).data });

  return (
    <PublicLayout>
      <PageContainer className="py-10">
        <PageHeader eyebrow="Articles" title="Blog" subtitle="News, updates and informational articles about Guwahati Morning Teer results." />

        {q.isLoading ? (
          <LoadingState />
        ) : q.isError ? (
          <ErrorState onRetry={q.refetch} />
        ) : q.data.length === 0 ? (
          <EmptyState title="No articles yet" subtitle="Check back soon for news and updates." />
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {q.data.map((post) => (
              <Link
                key={post.id}
                to={`/blog/${post.slug}`}
                data-testid={`blog-card-${post.slug}`}
                className="group rounded-2xl overflow-hidden bg-white border border-slate-100 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.06)] hover:-translate-y-1 hover:shadow-[0_14px_34px_-10px_rgba(76,29,149,0.22)] transition-transform"
              >
                <div className="aspect-video overflow-hidden bg-slate-100">
                  {post.image ? (
                    <img src={post.image} alt={post.title} className="w-full h-full object-cover" loading="lazy" />
                  ) : (
                    <div className="w-full h-full bg-brand-light" />
                  )}
                </div>
                <div className="p-5">
                  <span className="text-xs font-bold text-brand uppercase tracking-wider">{post.date}</span>
                  <h3 className="font-heading font-bold text-lg text-slate-900 mt-1.5 leading-snug">{post.title}</h3>
                  <p className="text-sm text-slate-500 mt-2 line-clamp-2">{post.excerpt}</p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-bold text-brand mt-3 group-hover:gap-2.5 transition-all">
                    Read more <ArrowRight className="w-4 h-4" weight="bold" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </PageContainer>
    </PublicLayout>
  );
}
